import IntercomProvider from './IntercomProvider';

export default IntercomProvider;
